<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table :headers="headers" :items="riskList" class="elevation-1" :loading="loading">
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.riskGrpNoRiskNo }}</td>
                <td>{{ row.item.busCls }} - {{ row.item.busClsDesc }}</td>
                <td>{{ row.item.siCurr }}</td>
                <td>{{ row.item.siExRate }}</td>
                <td>{{ row.item.comDateFormat }}</td>
                <td>{{ row.item.expDateFormat }}</td>
                <td>{{ row.item.delRisk }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doSelectRisk(row.item)" :loading="loading"></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.riskGrpNo }}</v-subheader>
          <span class="queryValue" v-if="riskForm.riskGrpNo">{{ riskForm.riskGrpNo }} - {{ riskForm.riskNo }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
          <span class="queryValue" v-if="riskForm.busCls">{{ riskForm.busCls }} - {{ riskForm.busClsDesc }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
          <span class="queryValue" v-if="riskForm.comDate">{{ formatDate(riskForm.comDate) }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
          <span class="queryValue" v-if="riskForm.expDate">{{ formatDate(riskForm.expDate) }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.siCurr }}</v-subheader>
          <span class="queryValue" v-if="riskForm.siCurr">{{ riskForm.siCurr }} - {{ riskForm.siCurrDesc }} ({{ riskForm.siExRate }})</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
        <!-- <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{labels.indGrp}}</v-subheader>
          <span class="queryValue" v-if="riskForm.indGrp">{{riskForm.indGrp}} - {{riskForm.indGrpDesc}}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex> -->
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.delRisk }}</v-subheader>
          <span class="queryValue" v-if="riskForm.delRisk">{{ riskForm.delRisk }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md4 xs12>
          <v-subheader class="queryLabel">{{ labels.stdRiskTxtRef }}</v-subheader>
          <span class="queryValue" v-if="riskForm.stdRiskTxtRef">{{ riskForm.stdRiskTxtRef }}</span>
          <span class="queryValue" v-else>-</span>
        </v-flex>
        <v-flex xs12>
          <v-textarea v-model="riskForm.stdRiskTxtRefDesc" :rows="3" readonly></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>

    <div>
      <v-expansion-panels>
        <!-- Bond Risk Details -->
        <QueryPolicyBondRisk v-if="riskForm.busClsAppID === 'BD'" ref="polBondRisk" :polRisk="riskForm"></QueryPolicyBondRisk>
        <QueryPolicyFireRisk v-if="riskForm.busClsAppID === 'FI'" ref="polFireRisk" :polRisk="riskForm"></QueryPolicyFireRisk>
        <QueryPolicyMotorRisk v-if="riskForm.busClsAppID === 'MO'" ref="polMotorRisk" :polRisk="riskForm"></QueryPolicyMotorRisk>
        <QueryPolicyHullRisk v-if="riskForm.busClsAppID === 'HU'" ref="polHullRisk" :polRisk="riskForm"></QueryPolicyHullRisk>
        <QueryPolicyCargoRisk v-if="riskForm.busClsAppID === 'CA'" ref="polCargoRisk" :polRisk="riskForm"></QueryPolicyCargoRisk>
        <!-- Employee Company Details -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-account-box</v-icon><span class="headerTitle">{{ labels.polEmpyeeDet }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6 md4 lg4>
                      <v-subheader class="queryLabel">{{ labels.polNo }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.polNo !== undefined">{{ empyeeDetForm.polNo }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs6 md4 lg4>
                      <v-subheader class="queryLabel">{{ labels.renCntEndtCnt }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.renCnt !== undefined && empyeeDetForm.endtCnt !== undefined">{{ empyeeDetForm.renCnt }} / {{ empyeeDetForm.endtCnt }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs6 md4 lg4>
                      <v-subheader class="queryLabel">{{ labels.riskGrpNoRiskNo }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.riskGrpNo !== undefined && empyeeDetForm.riskNo !== undefined">{{ empyeeDetForm.riskGrpNo }} / {{ empyeeDetForm.riskNo }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.empyeeCoUEN }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.empyeeCoUEN">{{ empyeeDetForm.empyeeCoUEN }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.empyeeCoName }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.empyeeCoName">{{ empyeeDetForm.empyeeCoName }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.dnldDate }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.dnldDate">{{ formatDate(empyeeDetForm.dnldDate) }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.empyeeCoName2 }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.empyeeCoName2">{{ empyeeDetForm.empyeeCoName2 }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.cancelDate }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.cancelDate">{{ formatDate(empyeeDetForm.cancelDate) }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.suspendDate }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.suspendDate">{{ formatDate(empyeeDetForm.suspendDate) }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.noEmpyeeInsd }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.noEmpyeeInsd">{{ empyeeDetForm.noEmpyeeInsd }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.termCode }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.termCode">{{ empyeeDetForm.termCode }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.injuredType }}</v-subheader>
                      <span class="queryValue" v-if="empyeeDetForm.injuredType">{{ empyeeDetForm.injuredType }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <QueryRiskAccumulation ref="polRiskBlk" :polRisk="riskForm"></QueryRiskAccumulation>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-sign-text</v-icon><span class="headerTitle">{{ labels.riskTextTitle }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-tabs v-model="riskTxtTabMenu" slider-color="teal">
                        <v-tab ripple :key="1">{{ labels.riskUppTxt }}</v-tab>
                        <v-tab ripple :key="2">{{ labels.riskLwrTxt }}</v-tab>
                        <v-tab ripple :key="3">{{ labels.riskMemo }}</v-tab>
                        <v-tab ripple :key="4">{{ labels.riskEndtTxt }}</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="riskTxtTabMenu">
                        <v-tab-item :key="1">
                          <v-card>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-textarea v-model="riskForm.riskUppTxt" :rows="10" readonly></v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item :key="2">
                          <v-card>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-textarea v-model="riskForm.riskLwrTxt" :rows="10" readonly></v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item :key="3">
                          <v-card>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-textarea v-model="riskForm.riskMemo" :rows="10" readonly></v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item :key="4">
                          <v-card>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-textarea v-model="riskForm.riskEndtTxt" :rows="10" readonly></v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- risk Clause -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-format-list-bulleted</v-icon><span class="headerTitle">{{ labels.riskClauseTitle }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        :headers="riskClse.headers"
                        :items="riskClse.items"
                        :loading="riskClse.loading"
                        :options.sync="riskClse.pagination"
                        item-key="clauseNo"
                        class="elevation-1"
                      >
                        <template v-slot:item="row">
                          <tr>
                            <td>{{ row.item.clauseNo }}</td>
                            <td>{{ row.item.clauseTitle }}</td>
                            <td>{{ row.item.clauseTxt }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- Risk Statistics -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-chart-areaspline</v-icon><span class="headerTitle">{{ labels.riskStatsTitle }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        :headers="polRiskStats.headers"
                        :items="polRiskStats.items"
                        item-key="statsType"
                        class="elevation-1"
                        :loading="polRiskStats.loading"
                        :options.sync="polRiskStats.pagination"
                      >
                        <template v-slot:items="row">
                          <tr>
                            <td>{{ row.item.statsType }}</td>
                            <td>{{ row.item.statsTypeDesc }}</td>
                            <td>{{ row.item.statsVal }}</td>
                            <td>{{ row.item.statsValDesc }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatYesNo } from '@/utils/boolean'
import { formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import QueryPolicyBondRisk from './QueryPolicyBondRisk'
import QueryPolicyCargoRisk from './QueryPolicyCargoRisk'
import QueryPolicyFireRisk from './QueryPolicyFireRisk'
import QueryPolicyHullRisk from './QueryPolicyHullRisk'
import QueryPolicyMotorRisk from './QueryPolicyMotorRisk'
import QueryRiskAccumulation from './QueryRiskAccumulation'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      labels: {
        query: 'Query',
        riskGrpNo: 'Risk Group / No.',
        busCls: 'Business Class',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        siCurr: 'Sum Insured Currency (Rate)',
        indGrp: 'Industry Group',
        delRisk: 'Deleted',
        stdRiskTxtRef: 'Standard Text',
        riskTextTitle: 'Risk Text',
        riskUppTxt: 'Upper',
        riskLwrTxt: 'Lower',
        riskMemo: 'Bordereaux',
        riskEndtTxt: 'Endorsement',
        riskClauseTitle: 'Risk Clause',
        riskStatsTitle: 'Risk Statistics',
        riskTrailerTitle: 'Risk Trailer',
        totGap: 'Net Annual Premium',
        premDue: 'Premium Due',
        disc: 'Discount',
        acctNo1: 'Billing Account No. 1',
        comm: 'Commission',
        redBal: 'Agent Commission Reducing Balance',
        riskStamp: 'Risk Stamp',
        riskFee: 'Risk Fee',
        riskTax: 'Risk Tax',
        totAfterAcct1: 'Total after Account 1',
        acctNo2: 'Billing Account No. 2',
        totAfterAcct2: 'Total after Account 2',
        acctNo3: 'Billing Account No. 3',
        totAfterAcct3: 'Total after Account 3',
        polEmpyeeDet: 'Employee Company Details',
        empyeeCoUEN: 'Company UEN',
        empyeeCoName: 'Company Name',
        empyeeCoName2: 'Company Name 2',
        dnldDate: 'Download MOM Date',
        cancelDate: 'Cancel Date',
        suspendDate: 'Suspend Date',
        noEmpyeeInsd: 'Total No. of Workers',
        polNo: 'Policy No.',
        renCntEndtCnt: 'Ren / EndtCnt',
        riskGrpNoRiskNo: 'Risk Grp / No.',
        termCode: 'Termination Code',
        injuredType: 'Injured Person Type'
      },
      headers: [
        { text: 'Risk No', align: 'left', value: 'riskGrpNoRiskNo' },
        { text: 'Class', value: 'busCls' },
        { text: 'SI Currency', value: 'siCurr' },
        { text: 'SI Currency Rate', value: 'siExRate' },
        { text: 'Com Date', value: 'comDate' },
        { text: 'Exp Date', value: 'expDate' },
        { text: 'Del Risk', value: 'delRisk' },
        TableConst.tableActionHeader
      ],
      riskList: [],
      loading: false,
      riskForm: {
        riskGrpNo: undefined,
        riskNo: undefined,
        delRisk: undefined,
        busCls: undefined,
        busClsDesc: undefined,
        comDate: undefined,
        expDate: undefined,
        siCurr: undefined,
        siCurrDesc: undefined,
        siExRate: undefined,
        indGrp: undefined,
        indGrpDesc: undefined,
        stdRiskTxtRef: undefined,
        stdRiskTxtRefDesc: undefined,
        busClsAppID: undefined,
        riskUppTxt: undefined,
        riskLwrTxt: undefined,
        riskMemo: undefined,
        riskEndtTxt: undefined,
        totGap: '0.00',
        premDue: '0.00',
        discPctAE: undefined,
        discPct: '0.00',
        discAE: undefined,
        disc: '0.00',
        acctName1: undefined,
        acctNoSfxDesc: undefined,
        // redBal1: undefined,
        comm1PctAE: undefined,
        comm1Pct: '0.00',
        comm1AE: undefined,
        comm1: '0.00',
        stampAE: undefined,
        feeAE: undefined,
        taxAE: undefined,
        stamp: '0.00',
        fee: '0.00',
        tax: '0.00',
        totAfterAcct1: '0.00',
        acctName2: undefined,
        acctNo2SfxDesc: undefined,
        // redBal2: undefined,
        comm2PctAE: undefined,
        comm2Pct: '0.00',
        comm2AE: undefined,
        comm2: '0.00',
        totAfterAcct2: '0.00',
        acctName3: undefined,
        acctNo3SfxDesc: undefined,
        // redBal3: undefined,
        comm3PctAE: undefined,
        comm3Pct: '0.00',
        comm3AE: undefined,
        comm3: '0.00',
        totAfterAcct3: '0.00'
      },
      riskTxtTabMenu: undefined,
      riskClse: {
        headers: [
          { text: 'Clauses', align: 'left', value: 'clauseNo' },
          { text: 'Clauses Title', value: 'clauseTitle' },
          { text: 'Clauses Text', value: 'clauseTxt' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        }
      },
      polRiskStats: {
        headers: [
          { text: 'Statistics Type', align: 'left', value: 'statsType' },
          { text: 'Description', value: 'statsTypeDesc' },
          { text: 'Statistics Value', value: 'statsVal' },
          { text: 'Description', value: 'statsValDesc' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        }
      },
      empyeeDetForm: {
        empyeeCoName: undefined,
        empyeeCoName2: undefined,
        noEmpyeeInsd: 0,
        empyeeCoUEN: undefined,
        suspendDate: '',
        cancelDate: '',
        dnldDate: '',
        termCode: '',
        injuredType: ''
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    doInit() {
      this.getRiskList().then(() => {
        if (this.riskList.length > 0) {
          this.setRisk(this.riskList[0])
        }
      })
    },
    async getRiskList() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.riskList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          const { data } = result
          if (data) {
            this.riskList = []
            data.data.map((risk) => {
              const convertRisk = {
                riskGrpNoRiskNo: risk.riskGrpNo.toString().padStart(2, '0') + '/' + risk.riskNo.toString().padStart(3, '0'),
                riskGrpNo: risk.riskGrpNo.toString().padStart(2, '0'),
                riskNo: risk.riskNo.toString().padStart(3, '0'),
                busCls: risk.busCls,
                busClsDesc: risk.busClsDesc,
                siCurr: risk.siCurr,
                siCurrDesc: risk.siCurrDesc,
                siExRate: risk.siExRate.toFixed(6),
                comDate: risk.comDate,
                comDateFormat: this.formatDate(risk.comDate),
                expDate: risk.expDate,
                expDateFormat: this.formatDate(risk.expDate),
                delRisk: formatYesNo(risk.delRisk),
                indGrp: risk.indGrp,
                indGrpDesc: risk.indGrpDesc,
                stdRiskTxtRef: risk.stdRiskTxtRef,
                stdRiskTxtRefDesc: risk.stdRiskTxtRefDesc,
                riskUppTxt: risk.riskUppTxt,
                riskLwrTxt: risk.riskLwrTxt,
                canFindPkgPlan: risk.canFindPkgPlan,
                newRiskNo: risk.newRiskNo,
                busClsAppID: risk.busClsAppID,
                riskMemo: risk.riskMemo,
                riskEndtTxt: risk.riskEndtTxt,
                riskClseList: risk.riskClseList,
                riskStatsList: risk.riskStatsList,
                totGap: formatPrice(risk.totGap),
                premDue: formatPrice(risk.premDue),
                discPctAE: risk.discPctAE,
                discPct: formatPrice(risk.discPct),
                discAE: risk.discAE,
                disc: formatPrice(risk.disc),
                acctName1: risk.acctName1,
                acctNoSfxDesc: risk.acctNoSfxDesc,
                comm1PctAE: risk.comm1PctAE,
                comm1Pct: formatPrice(risk.comm1Pct),
                comm1AE: risk.comm1AE,
                comm1: formatPrice(risk.comm1),
                stampAE: risk.stampAE,
                feeAE: risk.feeAE,
                taxAE: risk.taxAE,
                stamp: formatPrice(risk.stamp),
                fee: formatPrice(risk.fee),
                tax: formatPrice(risk.tax),
                totAfterAcct1: formatPrice(risk.totAfterAcct1),
                acctName2: risk.acctName2,
                acctNo2SfxDesc: risk.acctNo2SfxDesc,
                comm2PctAE: risk.comm2PctAE,
                comm2Pct: formatPrice(risk.comm2Pct),
                comm2AE: risk.comm2AE,
                comm2: formatPrice(risk.comm2),
                totAfterAcct2: formatPrice(risk.totAfterAcct2),
                acctName3: risk.acctName3,
                acctNo3SfxDesc: risk.acctNo3SfxDesc,
                comm3PctAE: risk.comm3PctAE,
                comm3Pct: formatPrice(risk.comm3Pct),
                comm3AE: risk.comm3AE,
                comm3: formatPrice(risk.comm3),
                totAfterAcct3: formatPrice(risk.totAfterAcct3)
              }
              this.riskList.push(convertRisk)
            })
            this.loading = false
          } else {
            this.riskList = []
            this.loading = false
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    setRisk(data) {
      if (data) {
        this.riskForm.riskGrpNo = data.riskGrpNo
        this.riskForm.riskNo = data.riskNo
        this.riskForm.delRisk = data.delRisk
        this.riskForm.busCls = data.busCls
        this.riskForm.busClsDesc = data.busClsDesc
        this.riskForm.comDate = data.comDate
        this.riskForm.expDate = data.expDate
        this.riskForm.siCurr = data.siCurr
        this.riskForm.siCurrDesc = data.siCurrDesc
        this.riskForm.siExRate = data.siExRate
        this.riskForm.indGrp = data.indGrp
        this.riskForm.indGrpDesc = data.indGrpDesc
        this.riskForm.stdRiskTxtRef = data.stdRiskTxtRef
        this.riskForm.stdRiskTxtRefDesc = data.stdRiskTxtRefDesc
        this.riskForm.busClsAppID = data.busClsAppID
        this.riskForm.riskUppTxt = data.riskUppTxt
        this.riskForm.riskLwrTxt = data.riskLwrTxt
        this.riskForm.riskMemo = data.riskMemo
        this.riskForm.riskEndtTxt = data.riskEndtTxt
        this.riskForm.totGap = data.totGap
        this.riskForm.premDue = data.premDue
        this.riskForm.discPctAE = data.discPctAE
        this.riskForm.discPct = data.discPct
        this.riskForm.discAE = data.discAE
        this.riskForm.disc = data.disc
        this.riskForm.acctName1 = data.acctName1
        this.riskForm.acctNoSfxDesc = data.acctNoSfxDesc
        this.riskForm.comm1PctAE = data.comm1PctAE
        this.riskForm.comm1Pct = data.comm1Pct
        this.riskForm.comm1AE = data.comm1AE
        this.riskForm.comm1 = data.comm1
        this.riskForm.stampAE = data.stampAE
        this.riskForm.feeAE = data.feeAE
        this.riskForm.taxAE = data.taxAE
        this.riskForm.stamp = data.stamp
        this.riskForm.fee = data.fee
        this.riskForm.tax = data.tax
        this.riskForm.totAfterAcct1 = data.totAfterAcct1
        this.riskForm.acctName2 = data.acctName2
        this.riskForm.acctNo2SfxDesc = data.acctNo2SfxDesc
        this.riskForm.comm2PctAE = data.comm2PctAE
        this.riskForm.comm2Pct = data.comm2Pct
        this.riskForm.comm2AE = data.comm2AE
        this.riskForm.comm2 = data.comm2
        this.riskForm.totAfterAcct2 = data.totAfterAcct2
        this.riskForm.acctName3 = data.acctName3
        this.riskForm.acctNo3SfxDesc = data.acctNo3SfxDesc
        this.riskForm.comm3PctAE = data.comm3PctAE
        this.riskForm.comm3Pct = data.comm3Pct
        this.riskForm.comm3AE = data.comm3AE
        this.riskForm.comm3 = data.comm3
        this.riskForm.totAfterAcct3 = data.totAfterAcct3

        this.getPolEmpyeeDet()

        this.riskClse.items = []
        if (data.riskClseList) {
          data.riskClseList.map((clause) => {
            const clauseList = {
              clauseNo: clause.clseNo,
              clauseTitle: clause.clseTitle,
              clauseTxt: clause.clseTxt
            }
            this.riskClse.items.push(clauseList)
          })
        }

        this.polRiskStats.items = []
        if (data.riskStatsList) {
          data.riskStatsList.map((statistic) => {
            const statisticList = {
              statsType: statistic.statsType,
              statsTypeDesc: statistic.statsTypeDesc,
              statsVal: statistic.statsValue,
              statsValDesc: statistic.statsValueDesc
            }
            this.polRiskStats.items.push(statisticList)
          })
        }

        if (this.riskForm.busClsAppID === 'FI') {
          if (this.$refs.polFireRisk) {
            this.$refs.polFireRisk.doInit()
          }
        } else if (this.riskForm.busClsAppID === 'BD') {
          if (this.$refs.polBondRisk) {
            this.$refs.polBondRisk.doInit()
          }
        } else if (this.riskForm.busClsAppID === 'MO') {
          if (this.$refs.polMtrRisk) {
            this.$refs.polMtrRisk.doInit()
          }
        } else if (this.riskForm.busClsAppID === 'HU') {
          if (this.$refs.polHullRisk) {
            this.$refs.polHullRisk.doInit()
          }
        } else if (this.riskForm.busClsAppID === 'CA') {
          if (this.$refs.polCargoRisk) {
            this.$refs.polCargoRisk.doInit()
          }
        }

        if (this.$refs.polRiskBlk) {
          this.$refs.polRiskBlk.doInit()
        }
      }
    },
    doSelectRisk(data) {
      this.setRisk(data)
    },
    async getPolEmpyeeDet() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polEmpyeeDet
      if (apiUrl) {
        this.loading = true
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.riskForm.riskGrpNo,
            riskNo: this.riskForm.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const data = result.data.data
          if (data) {
            this.empyeeDetForm.empyeeCoName = data.polEmpyeeDet.empyeeCoName
            this.empyeeDetForm.empyeeCoName2 = data.polEmpyeeDet.empyeeCoName2
            this.empyeeDetForm.noEmpyeeInsd = data.polEmpyeeDet.noEmpyeeInsd
            this.empyeeDetForm.empyeeCoUEN = data.polEmpyeeDet.empyeeCoUEN
            this.empyeeDetForm.suspendDate = data.polEmpyeeDet.suspendDate
            this.empyeeDetForm.cancelDate = data.polEmpyeeDet.cancelDate
            this.empyeeDetForm.dnldDate = data.polEmpyeeDet.dnldDate
            this.empyeeDetForm.polNo = data.polEmpyeeDet.polNo
            this.empyeeDetForm.renCnt = data.polEmpyeeDet.renCnt
            this.empyeeDetForm.endtCnt = data.polEmpyeeDet.endtCnt
            this.empyeeDetForm.riskGrpNo = data.polEmpyeeDet.riskGrpNo
            this.empyeeDetForm.riskNo = data.polEmpyeeDet.riskNo
            this.empyeeDetForm.termCode = data.polEmpyeeDet.termCode + data.polEmpyeeDet.termReason // OS-1887
            this.empyeeDetForm.injuredType = data.polEmpyeeDet.injuredType + data.polEmpyeeDet.injuredTypeDesc
          } else {
            this.resetEmpyeeDet()
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          this.resetEmpyeeDet()
          if (err.response) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        }
      }
    },
    resetEmpyeeDet() {
      this.empyeeDetForm.polNo = undefined
      this.empyeeDetForm.renCnt = undefined
      this.empyeeDetForm.endtCnt = undefined
      this.empyeeDetForm.riskGrpNo = undefined
      this.empyeeDetForm.riskNo = undefined
      this.empyeeDetForm.empyeeCoName = undefined
      this.empyeeDetForm.empyeeCoName2 = undefined
      this.empyeeDetForm.noEmpyeeInsd = undefined
      this.empyeeDetForm.empyeeCoUEN = undefined
      this.empyeeDetForm.suspendDate = undefined
      this.empyeeDetForm.cancelDate = undefined
      this.empyeeDetForm.dnldDate = undefined
      this.empyeeDetForm.termCode = undefined
      this.empyeeDetForm.injuredType = undefined
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  components: {
    QueryPolicyBondRisk,
    QueryPolicyCargoRisk,
    QueryPolicyFireRisk,
    QueryPolicyHullRisk,
    QueryPolicyMotorRisk,
    QueryRiskAccumulation
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style lang="scss" scoped>
.title {
  &.v-subheader {
    padding: 0px;
    height: inherit;
    font-size: 1.2em;
  }
}
.span-value {
  padding-left: 30px !important;
  height: inherit;
  font-size: 16px;
}
.tr-padding {
  padding-left: 40px !important;
}
</style>
